import { link_do_jogador }                                       from "@/utils/RpgFunction";

/* Jogadores de GET /rpg/jogadores. O endereco do perfil aceita o slug
   (nick do Roblox em minusculas, igual aos links antigos) ou o discordId. */
export function get_jogador_by_slug(slug, Jogadores) {
  if (!slug || !Array.isArray(Jogadores)) return undefined;
  const alvo = String(slug).toLowerCase();

  return Jogadores.find((jogador) => (
    jogador?.slug?.toLowerCase() === alvo ||
    jogador?.discordId === alvo ||
    jogador?.roblox?.username?.toLowerCase() === alvo
  ));
}

/* Link do perfil de um membro de crew ou dono de Rei: so existe para quem
   esta na lista de jogadores. Quem ficou fora dela (saiu do servidor, sem
   registro no RPG) vem com o slug igual ao discordId e o perfil responde 404. */
export function link_do_perfil(pessoa, Jogadores) {
  const jogador = get_jogador_by_slug(pessoa?.slug || pessoa?.discordId, Jogadores);
  return jogador ? link_do_jogador(jogador) : null;
}

const posicao_ou_fim = (posicao) => (typeof posicao === "number" ? posicao : Number.MAX_SAFE_INTEGER);

// ranking global: a API ja manda ordenado, mas a ordem nao pode depender disso
export function ordenar_por_posicao(Jogadores) {
  if (!Array.isArray(Jogadores)) return [];
  return Jogadores.filter(Boolean).sort((a, b) => posicao_ou_fim(a?.posicao) - posicao_ou_fim(b?.posicao) || (b?.xp || 0) - (a?.xp || 0));
}

export function get_five_members_top_rankings(Jogadores) {
  return ordenar_por_posicao(Jogadores).slice(0, 5);
}

/* Ranking de uma categoria (um Rei): so quem tem valor, do maior para o menor.
   A posicao e a da API; se vier null, vale a ordem da lista. */
export function ranking_da_categoria(chave, Jogadores) {
  if (!chave || !Array.isArray(Jogadores)) return [];

  return Jogadores
    .filter(Boolean)
    .map((jogador) => ({ jogador, valor: Number(jogador?.categorias?.[chave]?.valor) || 0, posicao: jogador?.categorias?.[chave]?.posicao ?? null }))
    .filter((linha) => linha.valor > 0)
    .sort((a, b) => b.valor - a.valor || posicao_ou_fim(a.posicao) - posicao_ou_fim(b.posicao) || (b.jogador?.xp || 0) - (a.jogador?.xp || 0))
    .map((linha, indice) => ({ ...linha, posicao: typeof linha.posicao === "number" ? linha.posicao : indice + 1 }));
}
